"use client";

import React, { createContext, useContext, useMemo } from "react";
import { useUTM, type UTMParams, type AttributionData } from "@/lib/hooks/useUTM";

interface UTMContextValue {
  utmParams: UTMParams;
  attributionData: AttributionData;
  getUTMParams: () => UTMParams;
  getAttributionData: () => AttributionData;
  getAllTrackingData: () => Record<string, any>;
}

const UTMContext = createContext<UTMContextValue | null>(null);

export function UTMProvider({ children }: { children: React.ReactNode }) {
  const { utmParams, attributionData, getUTMParams, getAttributionData, getAllTrackingData } = useUTM();

  const value = useMemo(
    () => ({
      utmParams,
      attributionData,
      getUTMParams,
      getAttributionData,
      getAllTrackingData,
    }),
    [utmParams, attributionData, getUTMParams, getAttributionData, getAllTrackingData]
  );

  return <UTMContext.Provider value={value}>{children}</UTMContext.Provider>;
}

export function useUTMContext() {
  const context = useContext(UTMContext);
  if (!context) {
    throw new Error("useUTMContext must be used within UTMProvider");
  }
  return context;
}
